import React from 'react';
import { useSnapshot } from 'valtio';

import ColorBar from './color_bar';

import { refsStore, datasetStore, videoStore } from '../managers/globalState';
import ar from '../languages/ar';

const DatasetItem = ({ item, handleSelection }) => {
	const { title, id, value, group, src } = item;
	const itemTitle = Array.isArray(title) ? title.pop() : title;

	return (
		<li
			key={`key-${id}`}
			data-value={value}
			data-group={group}
			onClick={handleSelection}
		>
			<figure>
				<img src={src} alt={itemTitle} />
				<figcaption>
					{itemTitle}
					&nbsp;›
				</figcaption>
			</figure>

			{/* <button className='text-left'>

			</button> */}
		</li>
	);
};


const DetailPanelRight = ({
	type, spacecraft, isMobile, handleSelection
}) => {
	const { get } = useSnapshot(refsStore.state);
	const { currentDataset } = useSnapshot(datasetStore.state);
	const { videoId } = useSnapshot(videoStore.state);

	// We need to check for the currentDataset as it allow the component to be reactive to the currentDataset change.
	if (currentDataset && type === 'vitalsign') {
		const { vitalData } = get('content');
		let cylThumbSrc = get('dataset').getCylThumbSrc();
		let altText = vitalData?.title;

		const videoManager = get('video');
		const videoType = videoManager.getVideoType(videoId);
		if (videoType === 'global' || videoType === 'geoLocated') {
			cylThumbSrc = `assets/images/graphics/${videoManager.getVideoThumbSrc(videoId)}`;
			altText = videoManager.getVideoThumbTitle(videoId);
		}

		return (
			<div className='right-content'>

				{/* ToDo: add suspense here with fallback once upgraded to react 18 */}
				{ cylThumbSrc && (
					<div className='thumb-container'>
						<img className='img-fluid no-drag mt-4 mt-lg-0 mx-lg-auto' src={cylThumbSrc} alt={altText} />
					</div>
				)}


				<ColorBar showDataRect={false} />
			</div>
		);
	}
	if (type === 'spacecraft') {
		const relatedDatasets = get('content').getRelatedDatasets(spacecraft);
	
		return relatedDatasets.length
			? (
				<div className='right-content col-12 col-lg-5 col-xl-6'>
					
					<h3 className='section-title d-none d-lg-block'>مجموعة البيانات</h3>
					{ isMobile && (<div className='section-title'>مجموعة البيانات</div>) }
					<ul className='scrollable'>
						{ relatedDatasets.map(item => <DatasetItem key={`key-${item.id}`} item={item} handleSelection={handleSelection} />) }
					</ul>
				</div>

			)
			: null;
	}
	return null;
};

export default DetailPanelRight;
